'use client';

import { sendGTMEvent } from '@next/third-parties/google';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

import { GTMBaseParams } from '../lib/types';
import { getPageCategory } from '../utils/getPageCategory';

interface GtmBaseEventProps {
  baseParams: Omit<GTMBaseParams, 'pageCategory'>;
}

export const GTMBaseEvent = ({ baseParams }: GtmBaseEventProps) => {
  const pathname = usePathname();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Исключаем первый рендер для отправки событий
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const pageCategory = getPageCategory(pathname);
    sendGTMEvent({ ...baseParams, pageCategory });
    sendGTMEvent({
      event: 'updatevirtualpath',
      virtualPageURL: pathname,
      virtualPageTitle: document.title
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const isBrowser = typeof window !== 'undefined';
  const isDataLayerEmpty =
    isBrowser &&
    (window?.dataLayer === undefined || window?.dataLayer?.length === 0);

  // Инициализируем dataLayer до загрузки GTM скрипта
  if (isDataLayerEmpty) {
    const pageCategory = getPageCategory(pathname);
    sendGTMEvent({ ...baseParams, pageCategory });
  }

  return null;
};
